module["exports"] = [
  "+## ### ## ## ####",
  "+## ## #######",
  "+## ## ########",
  "+## ### #######",
  "+## ### ########",
  "+## #### #######",
  "+## #### ########",
  "0## ### ####",
  "+39 0## ### ###",
  "3## ### ###",
  "+39 3## ### ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/phone_number/formats.js
 ** module id = 703
 ** module chunks = 0
 **/